import styled, { createGlobalStyle } from "styled-components";
import { space } from "styled-system";

import { ALink, FlexContainer, FlexDiv } from "@/components/Atoms/Box";
import Typography from "@/foundation/Typography/V1";

export const Heading = styled(Typography)`
  font-family: var(--font-400);
`;
export const Container = styled(FlexContainer)`
  margin: 40px auto auto;
  justify-content: center;
`;
export const AlphaList = styled.li`
  list-style-type: ${({ capital }) =>
    capital ? "upper-alpha" : "lower-alpha"};
  margin-bottom: 12px;
  &:last-child {
    margin-bottom: 0px;
  }
`;
export const RomanList = styled.li`
  list-style-type: lower-roman;
  margin-bottom: 12px;
  &:last-child {
    margin-bottom: 0px;
  }
`;
export const Wrapper = styled(FlexDiv)`
  padding: ${(props) => {
    return props.showHeightGap ? "110px 0px" : "10px 0px 50px 0px";
  }};
  p {
    margin-bottom: 11px;
    &:last-child {
      margin-bottom: 0px;
    }
  }
`;
export const OL = styled.ol`
  ${space}
  ol {
    padding-inline-start: 40px !important;
  }
  counter-reset: item;
  > li {
    padding-left: 0px;
    li {
      padding-left: 0px;
    }
    ${AlphaList} {
      padding-left: 0;
    }
    ${Heading} {
      margin-bottom: 25px;
    }
  }
`;
export const LI = styled.li`
  ${space}
  display: block;
  margin-bottom: 12px;
  &:last-child {
    margin-bottom: 0px;
  }
  position: relative;
  &:before {
    display: inline-block;
    float: left;
    margin-right: 5px;
    content: counters(item, ".") ".";
    counter-increment: item;
    font-size: 12px;
    font-family: var(--font-400);
    color: ${({ theme }) => theme.colors.gray_100};
    @media only screen and (min-width: 640px) {
      font-size: 14px;
    }
    @media only screen and (min-width: 960px) {
      font-size: 16px;
    }
  }
`;
export const Strong = styled.strong`
  font-size: inherit;
  font-family: var(--font-700);
  color: inherit;
`;
export const SUBOL = styled(OL)`
  counter-reset: item;
`;
export const Link = styled(ALink)`
  font-size: inherit;
  font-family: inherit;
  color: ${({ theme }) => theme.colors.dotsColor};

  &:hover {
    color: ${({ theme }) => theme.colors.dotsColor};
  }
`;
export const ItalicText = styled.i`
  font-size: inherit;
  font-family: inherit;
  color: inherit;
  font-style: italic;
`;
export const GlobalCss = createGlobalStyle`
::marker {
    font-size: 12px;
    color: ${({ theme }) => theme.colors.gray_100};
    font-family: 'Raleway',sans-serif;
    @media only screen and (min-width: 640px) {
    font-size: 14px;
    }
    @media only screen and (min-width: 960px) {
    font-size: 16px;
    }
}
  `;
export const TableBox = styled(FlexDiv)`
  border: 1px solid ${({ theme }) => theme.colorsV2.gray.shade_700};
  flex-direction: column;
`;
export const Data = styled(Typography)`
  color: ${({ theme }) => theme.colorsV2.gray.shade_700};
  width: 100%;
  max-width: 50%;
  text-align: center;
  display: flex;
  align-items: center;
  margin-bottom: 0 !important;
  padding: 8px;
  border-right: 1px solid ${({ theme }) => theme.colorsV2.gray.shade_700};
  &:last-child {
    border-right: 0;
  }
`;
export const TableHeader = styled(FlexDiv)`
  border-bottom: 1px solid ${({ theme }) => theme.colorsV2.gray.shade_700};
  width: 100%;
`;
export const TableData = styled(TableHeader)`
  width: 100%;
  flex-direction: column;
  border-bottom: 0;
`;
export const TableRow = styled(FlexDiv)`
  border-bottom: 1px solid ${({ theme }) => theme.colorsV2.gray.shade_700};

  &:last-child {
    border-bottom: 0;
  }
`;
